import { render, staticRenderFns } from "./appVillage.vue?vue&type=template&id=539a9416&scoped=true&"
import script from "./appVillage.vue?vue&type=script&lang=js&"
export * from "./appVillage.vue?vue&type=script&lang=js&"
import style0 from "./appVillage.vue?vue&type=style&index=0&id=539a9416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539a9416",
  null
  
)

export default component.exports